import { Link } from 'react-router-dom';

export default function HomeIntro() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="relative">
            <div className="relative rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=African%20logistics%20professionals%20with%20dark%20skin%20tones%20working%20together%20in%20a%20modern%20freight%20warehouse%2C%20Black%20men%20and%20women%20wearing%20orange%20safety%20vests%20reviewing%20shipping%20documents%20and%20organizing%20cargo%20boxes%20on%20wooden%20pallets%2C%20warm%20natural%20sunlight%20through%20tall%20windows%2C%20bright%20clean%20industrial%20interior%20background%2C%20editorial%20corporate%20photography%2C%20high%20detail%2C%20confident%20and%20friendly%20team%20spirit&width=900&height=700&seq=gls-home-intro&orientation=landscape&nocache=true"
                alt="Godwin Logistics entrepôt"
                className="w-full h-[440px] md:h-[520px] object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-4 md:-right-8 bg-primary-500 text-white p-6 rounded-lg max-w-xs">
              <div className="font-heading text-4xl font-bold">2026</div>
              <div className="text-sm mt-1 text-white/90">Une nouvelle référence maritime</div>
            </div>
          </div>

          <div>
            <span className="text-primary-600 text-sm font-semibold uppercase tracking-widest">À propos</span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 mt-3 leading-tight">
              La mer, extension fluide de votre chaîne logistique
            </h2>
            <p className="mt-6 text-foreground-700 leading-relaxed">
              Fondé en 2026, <strong>Godwin Logistics</strong> s'est développé pour devenir un commissionnaire de transport international de référence.
              Spécialisé dans le fret maritime, nous connectons les continents et accompagnons les clients dans le déploiement de leurs flux de colis provenant de la Chine.
            </p>
            <p className="mt-4 text-foreground-700 leading-relaxed">
              Notre mission : assurer le transport sécurisé, économique et fiable de vos colis par voie maritime et routière, avec une prise en charge complète des formalités douanières.
            </p>

            <div className="mt-8 grid grid-cols-2 gap-4">
              {[
                { i: 'ri-earth-line', t: 'Hubs stratégiques', d: 'Chine (Guangzhou, Shenzhen, Yiwu)' },
                { i: 'ri-shield-check-line', t: 'Douane maîtrisée', d: 'Import & export sans stress' },
                { i: 'ri-home-4-line', t: 'Siège social', d: 'Bâtiment AMAZON, Lubumbashi' },
                { i: 'ri-exchange-dollar-line', t: 'Fonds', d: 'Bank, WeChat, Alipay' },
              ].map((f, i) => (
                <div key={i} className="p-4 rounded-md bg-background-100 border border-background-200">
                  <div className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-white mb-3">
                    <i className={`${f.i} text-lg`}></i>
                  </div>
                  <div className="font-semibold text-foreground-900 text-sm">{f.t}</div>
                  <div className="text-xs text-foreground-600 mt-1">{f.d}</div>
                </div>
              ))}
            </div>

            <Link to="/a-propos" className="inline-flex items-center gap-2 mt-8 px-6 py-3 rounded-md bg-foreground-900 hover:bg-foreground-800 text-white text-sm font-semibold cursor-pointer whitespace-nowrap transition">
              Découvrir Godwin Logistics <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}